interface Callback extends Function {}

interface Pollified extends Function {
  clear: () => void;
}

interface LegacyDocument extends Document {
  hasFocus: () => boolean;
}

const pollify = function(func: Callback, threshold: number): Pollified {
  const pollInterval: number = threshold + Math.random() * 5;
  let lastCheck: number = 0;
  let intervalId: number = 0;

  const isDocumentFocused = (): boolean => {
    if ('hidden' in document) {
      return !document.hidden;
    } else if ((document as LegacyDocument).hasFocus) {
      return (document as LegacyDocument).hasFocus();
    }

    return true;
  };

  const runTask = () => {
    const isPastInterval = !lastCheck || Date.now() - lastCheck > pollInterval;
    if (isDocumentFocused() && isPastInterval) {
      try {
        func();
      } catch (e) {
        // fail silently
      } finally {
        lastCheck = Date.now();
      }
    }
  };

  window.addEventListener('focus', runTask);

  const clear = () => {
    window.clearInterval(intervalId);
    window.removeEventListener('focus', runTask);
  };

  intervalId = window.setInterval(runTask, pollInterval / 4);

  const pollified: Pollified = (() => {
    // tslint:disable-next-line:no-any
    const f: any = runTask;
    f.clear = clear;

    return f;
  })();

  return pollified;
};

export default pollify;



// WEBPACK FOOTER //
// ./app/common/lib/util/pollify.ts